export default "__VITE_ASSET__8f3d67e3__"